// extracted by mini-css-extract-plugin
export default {"cls1":"Banner-cls1___df75954dcbcb6797511","cls2":"Banner-cls2___3df08524d5da665ad74 Banner-cls1___df75954dcbcb6797511"};